import { createEventBus } from '@/event-bus';

export const htmlEditorEventBus = createEventBus();
